<template>
  <div>
    <v-card
      class="rounded-card"
      style="box-shadow: 15px 15px 40px #00000029;border-radius: 20px;"
    >
      <div
        class="next-step-header d-flex justify-space-between align-center px-10 py-6"
      >
        <p class="font-weight-medium">
          Next Step
        </p>
        <v-icon
          large
          color="white"
        >
          mdi-bell
        </v-icon>
      </div>
      <div class="next-step-content px-10">
        <p class="secondary--text font-weight-bold">
          Your Next Steps
        </p>
        <p class="secondary--text pb-5">
          After you file, the court will send you a notification that includes the case number and hearing date. In the future, we’ll guide you all the way through to the end. For now, be sure to contact the court or seek legal counsel for any questions pertaining to your proceeding.
        </p>
      </div>
      <div class="next-step-footer px-10 py-6">
        <div class="step-status">
          Pending
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "NextStep",
  props: {
    currentCase: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style>
  .next-step-header {
    background-color: #4DCCC4;
  }
  .next-step-header p {
    color: white;
    margin: 0;
    font-size: 1.25rem;
  }
  .next-step-header i {
    transform: rotate(20deg);
  }
  .next-step-content {
    padding: 40px 0 10px 0;
  }
  .next-step-footer {
    background-color: #F8FAFB;
  }

  .bullet-priority {
    width: 16px;
    height: 16px;
    background: #FF854E;
    border: 1px solid #FF854E;
    border-radius: 50%;
    margin-right: 6px;
    align-self: center;
  }

  .step-status {
    text-align: center;
    padding: 5px 20px;
    width: 130px;
    border-radius: 23px;
    background-color: #DAE3E9;
    font-size: 18px;
    color: #8BA4B4;
    font-style: italic;
  }
</style>